// removed by extract-text-webpack-plugin
module.exports = {"NavigationItems":"NavigationItems__NavigationItems__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/NavigationItems/NavigationItems.scss
// module id = 117
// module chunks = 0